import React, { useMemo } from "react";
import { useLocation, Link } from "react-router-dom";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function PayCancelPage() {
  const q = useQuery();
  const ref = q.get("iid") || q.get("rid") || "";

  const boxStyle = {
    maxWidth: 760,
    margin: "28px auto",
    padding: 18,
    borderRadius: 16,
    border: "1px solid #e5e7eb",
    background: "#fff",
  };

  const wrapStyle = {
    minHeight: "70vh",
    background: "#f3f4f6",
    padding: "24px 12px",
  };

  return (
    <div style={wrapStyle}>
      <div style={boxStyle}>
        <div style={{ fontWeight: 900, fontSize: 18, color: "#111827" }}>
          Payment cancelled
        </div>

        <div style={{ marginTop: 8, color: "#6b7280" }}>
          You cancelled the payment flow. No charge was confirmed.
        </div>

        {ref && (
          <div style={{ marginTop: 12, color: "#111827", fontWeight: 800 }}>
            Reference: {ref}
          </div>
        )}

        <div style={{ marginTop: 14 }}>
          <Link to="/" style={{ color: "#111827", fontWeight: 800 }}>
            Return to home
          </Link>
        </div>
      </div>
    </div>
  );
}
